<mat-form-field>
  <mat-label>{{label}}</mat-label>
  <input
    matInput
    class="transparentInput"
    [(ngModel)]="dataDate"
    [matDatepicker]="picker"
    (dateChange)="onFocusOut($event)"
    (keydown.escape)="undo()"
    disabled
  >
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
